import styled from 'styled-components'

const TuFulfilmentBox = styled.div`
  margin-top: 25px;
`
const TuFulfilmentPrice = styled.p`
  align-self: flex-start;
`

const Label = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: 10px;

  .info-details {
    display: inherit;
  }

  .title {
    position: relative;
    padding-left: 8px;
  }

  @media only screen and (max-width: $screen-md-max) {
    font-size: 90%;
  }

  p {
    margin-bottom: 0;
  }
`

export { TuFulfilmentBox, TuFulfilmentPrice, Label }
